import React from 'react';

export const OtherAppSmash: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill="#A5A5A5" />
    <path
      d="M9 13C10.1046 13 11 13.8954 11 15C11 16.1046 10.1046 17 9 17C7.89543 17 7 16.1046 7 15C7 13.8954 7.89543 13 9 13Z"
      fill="white"
    />
    <path
      d="M15 13C16.1046 13 17 13.8954 17 15C17 16.1046 16.1046 17 15 17C13.8954 17 13 16.1046 13 15C13 13.8954 13.8954 13 15 13Z"
      fill="white"
    />
    <path
      d="M23 15C23 13.8954 22.1046 13 21 13C19.8954 13 19 13.8954 19 15C19 16.1046 19.8954 17 21 17C22.1046 17 23 16.1046 23 15Z"
      fill="white"
    />
  </svg>
);

export default OtherAppSmash;
